// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportingDetailsCollectionsPage_wrapper__nyAJM"};